import React from 'react'
import PropTypes from 'prop-types'

import { Container, ContainerImage, Title } from './style'

const Hero = ({ title, image, auto }) => (
  <Container auto={auto}>
    <ContainerImage image={image.file.url}>
      <div className='container'>
        <Title className='hero-title'>{title}</Title>
      </div>
    </ContainerImage>
  </Container>
)

Hero.propTypes = {
  title: PropTypes.string,
  image: PropTypes.object,
  auto: PropTypes.bool
}

Hero.defaultProps = {
  title: 'Node.js content made by the community for the community',
  image: {
    file: {
      url: '/assets/img/home-hero.jpg'
    }
  },
  auto: true
}

export default Hero
